import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { SampleComponent } from './sample/sample.component';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainviewComponent } from './mainview/mainview.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { MobileVerificationComponent } from './mobileverification/mobileverification.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { CurrentInventoryComponent } from './current-inventory/current-inventory.component';
import { ProfileComponent } from './profile/profile.component';
import { ApprovalprimaryuserComponent } from './approvalprimaryuser/approvalprimaryuser.component';
import { ShoppingcartComponent } from './shoppingcart/shoppingcart.component';
import { OrderhistoryComponent } from './orderhistory/orderhistory.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { VendormastersComponent } from './vendormasters/vendormasters.component';
import { OpenordersComponent } from './openorders/openorders.component';
import { ExportLogsComponent } from './exportlogs/exportlogs.component';
import { ErrorComponent } from './error/error.component';
import { EmailverificationenduserComponent } from './emailverificationenduser/emailverificationenduser.component';

import { AdminusermanagementComponent } from './adminusermanagement/adminusermanagement.component';
import { RolemanagementComponent } from './rolemanagement/rolemanagement.component';
import { UsermanagmentComponent } from './usermanagment/usermanagment.component';
import { SavedListManagementComponent } from './saved-list-management/saved-list-management.component';
import { SystemlogsmanagementComponent } from './systemlogsmanagement/systemlogsmanagement.component';
import { PagecontentmanagementComponent } from './pagecontentmanagement/pagecontentmanagement.component';
import { BannermanagementComponent } from './bannermanagement/bannermanagement.component';
import { AppnotificationmanagementComponent } from './appnotificationmanagement/appnotificationmanagement.component';
import { AppnotificationtextmanagementComponent } from './appnotificationtextmanagement/appnotificationtextmanagement.component';
import { SmsnotificationmangementComponent } from './smsnotificationmangement/smsnotificationmangement.component';
import { SmsnotificationtextmanagementComponent } from './smsnotificationtextmanagement/smsnotificationtextmanagement.component';
import { EmailnotificationmanagementComponent } from './emailnotificationmanagement/emailnotificationmanagement.component';
import { EmailnotificationttextmanagementComponent } from './emailnotificationttextmanagement/emailnotificationttextmanagement.component';
import { GiveawaymanagementComponent } from './giveawaymanagement/giveawaymanagement.component';
import { BiddingmanagementComponent } from './biddingmanagement/biddingmanagement.component';
import { VendoraccountmangementComponent } from './vendoraccountmangement/vendoraccountmangement.component';
import { VendorproductmanagementComponent } from './vendorproductmanagement/vendorproductmanagement.component';
import { OrdermanagementComponent } from './ordermanagement/ordermanagement.component';
import { CancelledordermanagementComponent } from './cancelledordermanagement/cancelledordermanagement.component';
import { ReportsmanagementComponent } from './reportsmanagement/reportsmanagement.component';
import { UseraccountmanagementComponent } from './useraccountmanagement/useraccountmanagement.component';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';

import { ModuleWithProviders} from "@angular/core";
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import { ReactiveFormsModule} from '@angular/forms';
import { ToastrModule } from 'ng6-toastr-notifications';
import {TableUtil} from '../app/tableUtil'
import * as XLSX from "xlsx";
import { Ng2DeviceService } from 'ng2-device-detector';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ProductCategoryComponent } from './product-category/product-category.component';
import { ProductSubCategoryComponent } from './product-sub-category/product-sub-category.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxSliderModule } from "@angular-slider/ngx-slider";

import{ TokenInterceptorService} from './service/token-interceptor.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountsManagementComponent } from './accounts-management/accounts-management.component'
@NgModule({
  declarations: [
    AppComponent,ProductCategoryComponent,ProductSubCategoryComponent,
    MainviewComponent,
    DashboardComponent,
    LoginComponent,
    EmailVerificationComponent,
    ForgetpasswordComponent,
    MobileVerificationComponent,
    CurrentInventoryComponent,
    ProfileComponent,
    ApprovalprimaryuserComponent,
    ShoppingcartComponent,
    OrderhistoryComponent,
    NotificationsComponent,
    VendormastersComponent,
    OpenordersComponent,
    ExportLogsComponent,
    AdminusermanagementComponent,
    RolemanagementComponent,
    UsermanagmentComponent,
    SavedListManagementComponent,
    SystemlogsmanagementComponent,
    PagecontentmanagementComponent,SampleComponent,
    BannermanagementComponent,
    AppnotificationmanagementComponent,
    AppnotificationtextmanagementComponent,
    SmsnotificationmangementComponent,
    SmsnotificationtextmanagementComponent,
    EmailnotificationmanagementComponent,
    EmailnotificationttextmanagementComponent,
    GiveawaymanagementComponent,
    BiddingmanagementComponent,
    VendoraccountmangementComponent,
    VendorproductmanagementComponent,
    OrdermanagementComponent,
    CancelledordermanagementComponent,
    ReportsmanagementComponent,
    UseraccountmanagementComponent,EmailverificationenduserComponent,
   
   ErrorComponent,
   
   ChangePasswordComponent,
   
   AccountsManagementComponent
  ],
  imports: [      NgIdleKeepaliveModule.forRoot(),    BsDatepickerModule.forRoot(),

    BrowserModule,BrowserAnimationsModule,ReactiveFormsModule,ToastrModule.forRoot(),CKEditorModule,

    AppRoutingModule,FormsModule,HttpClientModule, MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,NgxSliderModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatNativeDateModule
  ], 
  exports: [
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatNativeDateModule
],
  providers: [
   {provide: LocationStrategy, useClass: HashLocationStrategy  },
    {provide: HTTP_INTERCEPTORS,useClass:TokenInterceptorService,multi:true

    },{provide:Ng2DeviceService}




  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
